export default "__VITE_ASSET__DwuQhaf3__"